// action types
import {
    SAVE_USERINFO,
    CLEAR_STATE,
} from '../constants/actionType';

// initial state
const initialState = {
    userInfo: JSON.parse('{}'),
};

// reducer
export default function userReducer(state = initialState, action: any) {
    switch (action.type) {
        case SAVE_USERINFO:
            return {
                ...state,
                userInfo: action.userInfo,
            };
        case CLEAR_STATE:
            return initialState;
        default:
            return state;
    }
}

